import { mutationTypes, actionTypes } from 'BASE/store/types';
import userinfoStore from 'BASE/store/userInfo/userInfo.store';
import lottoinfoStore from 'BASE/store/bet/bet.store.lottogame';
import signalr from 'BASE/common/signalrAdapter';

export default {
    data: function () {
        return {
            CountdownTimer: null,
            // 預設的資料撈取配置，商戶可在自己的 data 中覆寫此屬性
            dataConfig: {
                // 必須先執行的項目，有順序性
                required: [
                    actionTypes.USER_INFO_INIT,
                    actionTypes.USER_INFO_MERCHANT_CODE,
                ],
                // 可並行執行的項目
                parallel: [
                    actionTypes.CHAT_INFO,
                    actionTypes.USER_INFO_PRIVILEGES,
                    actionTypes.USER_INFO_PRIVILEGES_BONUS,
                    actionTypes.USER_INFO_REGISTER_LINK_CODE,
                    actionTypes.USER_INFO_DEMO_LINK, //試玩
                    actionTypes.USER_INFO_IS_WECHAT_ENABLED,
                    actionTypes.LOTTOGAME_DATA,
                    actionTypes.USER_INFO_GET_BASE_DATA,
                    actionTypes.USER_INFO_ALERTS,
                    actionTypes.VIP_INFO,
                    actionTypes.USER_INFO_TELEGRAM_BOT,
                ]
            }
        };
    },
    methods: {
        async updateWalletAmount() {
            await this.$store.dispatch(actionTypes.USER_INFO_WALLET_AMOUNT);
        }
    },
    async mounted() {
        let _this = this;
        //如有收到變更權限就通知store變更
        signalr.addWorkOnConnected(() => {
            signalr.userInfoPrivilegesClient.userInfoPrivileges.addHandler(input => {
                _this.$store.dispatch(actionTypes.USER_INFO_PRIVILEGES);
                _this.$store.dispatch(actionTypes.USER_INFO_PRIVILEGES_BONUS);
            });
        });

        // 執行必須先執行的項目
        for (const action of this.dataConfig.required) {
            await this.$store.dispatch(action);
        }

        // 並行執行所有獨立的 API 呼叫
        if (this.dataConfig.parallel && this.dataConfig.parallel.length > 0) {
            await Promise.all(
                this.dataConfig.parallel.map(action => _this.$store.dispatch(action))
            );
        }
        
        await this.updateWalletAmount();

        this.$store.commit(mutationTypes.USER_INFO_INITIALIZED, { initialized: true });
        this.CountdownTimer = setInterval(this.updateWalletAmount, 10000); //預設每10秒刷新一次
    },
    beforeDestroy() {
        clearInterval(this.CountdownTimer);
        this.$store.unregisterModule('userinfo');
        this.$store.unregisterModule('lottoinfo');

        if (signalr.isInitialized) {
            signalr.userInfoPrivilegesClient.userInfoPrivileges.clearHandler();
        }
    },
    beforeCreate() {
        this.$store.registerModule('userinfo', new userinfoStore());
        this.$store.registerModule('lottoinfo', new lottoinfoStore());
    },
}